import { r2wc } from '#/r2wc';
import { TimeDashboardToggleComponent } from './TimeDashboardToggleComponent';

const _TimeDashboardToggleComponent = r2wc(TimeDashboardToggleComponent, {
  hideAndReset: 'boolean',
  personKey: 'string',
});

customElements.define(
  'unanet-time-dashboard-toggle',
  _TimeDashboardToggleComponent
);
